module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-foot"
  }, [_c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "mobile-footer"
  }, [_c('div', {
    staticClass: "made-by",
    class: {
      'hide': _vm.isOpenedInIFrame
    }
  }, [_vm._v("Developed by "), _c('a', {
    attrs: {
      "href": "https://peppersalts.in",
      "target": "_blank"
    }
  }, [_vm._v("Peppersalts Studio")]), _vm._v(" | "), _c('icon', {
    attrs: {
      "name": "calendar",
      "height": "12"
    }
  }), _vm._v(" 2018")], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c13f41d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterHero.vue
// module id = 1075
// module chunks = 1